module.exports = __webpack_public_path__ + "static/media/10H.14415155.svg";